<mat-toolbar
  class="wcg-toolbar fixed top-0"
  [ngClass]="{
    'wcg-toolbar_impersonate': impersonateBanner(),
    'top-0': !impersonateBanner(),
  }"
  data-testid="wcg-toolbar"
>
  <div
    class="wcg-toolbar__half wcg-toolbar__half--first"
    data-testid="wcg-toolbar__half--first"
  >
    <div class="wcg-toolbar__item">
      <span fxFlex data-testid="wcg-toolbar__app-logo-container">
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        <a
          routerLink="/"
          class="wcg-toolbar__logo"
          data-testid="wcg-toolbar__app-logo"
        ></a>
      </span>
    </div>
    <div class="wcg-toolbar__item" data-testid="wcg-toolbar__app-title">
      eReview Manager
    </div>
    <div class="wcg-toolbar__item">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" data-testid="mat-tab-nav-bar">
        @for (link of $menuLinks(); track link.label) {
          <a
            mat-tab-link
            data-testid="mat-tab-link"
            [attr.data-testid]="link.label"
            [attr.href]="link.route"
            (click)="onTabChange(link.route, $event)"
            [active]="$activeLink().includes(link.route)"
            class="no-underline"
          >
            {{ link.label }}
          </a>
        }
        @if ($isInternalUser() && $profileLinks().length > 0) {
          <a
            mat-tab-link
            [active]="$activeLink().includes('profiles')"
            data-testid="menu-profiles-dropdown"
            [matMenuTriggerFor]="profilesMenu"
            (menuOpened)="profileMenuOpen.set(true)"
            (menuClosed)="profileMenuOpen.set(false)"
          >
            Profiles
            <mat-icon>{{
              profileMenuOpen() ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          </a>
        }
        @if ($isInternalUser()) {
          <a
            mat-tab-link
            [active]="$activeLink().includes('admin')"
            data-testid="menu-admin-dropdown"
            [matMenuTriggerFor]="adminMenu"
            (menuOpened)="adminMenuOpen.set(true)"
            (menuClosed)="adminMenuOpen.set(false)"
          >
            Admin
            <mat-icon>{{
              adminMenuOpen() ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          </a>
        }
      </nav>

      <mat-tab-nav-panel #tabPanel />
      <mat-menu #adminMenu="matMenu" data-testid="admin-menu">
        @for (tab of $adminLinks(); track tab.label) {
          <div>
            <a
              [attr.data-testid]="tab?.label"
              [attr.href]="tab.route"
              (click)="onTabChange(tab.route, $event)"
              class="no-underline"
            >
              <button mat-menu-item data-testid="admin-menu-link-btn">
                <span data-testid="admin-menu-text">{{ tab.label }}</span>
              </button>
            </a>
          </div>
        }
        @if ($aiIrbAdminLinks().length > 0) {
          <mat-divider />
          @for (tab of $aiIrbAdminLinks(); track tab.label) {
            <a
              [attr.data-testid]="tab.label"
              [attr.href]="tab.route"
              class="no-underline"
            >
              <button mat-menu-item data-testid="ai-irb-admin-menu-link-btn">
                <span data-testid="admin-menu-text">{{ tab.label }}</span>
              </button>
            </a>
          }
        }
      </mat-menu>

      <mat-menu #profilesMenu="matMenu" data-testid="profiles-menu">
        @for (tab of $profileLinks(); track tab.label) {
          <div>
            <a
              [attr.data-testid]="tab.label"
              [attr.href]="tab.route"
              (click)="onTabChange(tab.route, $event)"
              class="no-underline"
            >
              <button mat-menu-item data-testid="profiles-menu-link-btn">
                <span data-testid="profiles-menu-text">{{ tab.label }}</span>
              </button>
            </a>
          </div>
        }
      </mat-menu>
    </div>
  </div>

  <div
    class="wcg-toolbar__half wcg-toolbar__half--second"
    data-testid="wcg-toolbar__half--second"
  >
    @if ($isImpersonating()) {
      <wcg-chip
        data-testid="wcg-toolbar__internal-chip"
        class="wcg-toolbar__internal-chip"
        [label]="$impersonationText()"
        [type]="chipType"
        leadingIcon="people"
      />
    }
    @if ($isInternalUser()) {
      <wcg-chip
        data-testid="wcg-toolbar__internal-chip"
        class="wcg-toolbar__internal-chip"
        label="Internal"
        [type]="chipType"
        leadingIcon="people"
      />
    }

    <button
      type="button"
      class="resource_icon wcg-toolbar__internal-chip"
      routerLink="/user/resources"
      [queryParams]="{
        isImpersonating: impersonateBanner(),
      }"
      data-testid="wcg-toolbar_resources-chip"
      matTooltip="Resources"
    >
      <span class="material-symbols-outlined school-icon"> school </span>
    </button>

    @if ($isAuthenticated()) {
      <wcg-headeruser-menu
        data-testid="wcg-toolbar__headeruser-menu"
        [isAuthenticated]="$isAuthenticated()"
      />
    }
  </div>
</mat-toolbar>
